import React from 'react';
import { CircularProgress, CircularProgressProps } from '@mui/material';

// the global svg size rule (neu.css) would shrink the svg inside the rotating
// box and make the arc orbit off-center
const CircularProgressFixed: React.FC<CircularProgressProps> = ({ sx, ...props }) => (
  <CircularProgress
    aria-label='loading'
    {...props}
    sx={{ '& svg': { width: '100%', height: '100%' }, ...sx }}
  />
);

export default CircularProgressFixed;
